"use strict";
/**
 * @author Simone Bosco <simone@clickcreative.com.au>
 * @author Click Creative <support@clickcreative.com.au>
 * @copyright 2017 Click Creative
 * @package Neoscape/Template
 * @since 10/2017
 */
//------------------------------------------------------------------------------
//
//------------------------------------------------------------------------------
import blueimp from 'blueimp-gallery';

export default () => {
  (function ($) {
    $(window).on('load', function () {
      var mmenu = $(".js-menu");
      var mmenuTrigger = $(".js-menu-trigger");
      mmenuTrigger.on('click', function (ev) {
        ev.preventDefault();
        mmenu.toggleClass('active');
        fancystuff.toggleClass('is-ready');
      });

      var menuLevel = $('.js-menu-level');
      var menuNext = $('.js-menu-next');
      var menuPrev = $('.js-menu-prev');
      menuNext.on('click', function (ev) {
        ev.preventDefault();
        var level = $(this).data('level');
        var id = $(this).data('id');
        menuLevel.hide();
        menuLevel.filter("[data-level=" + level + "][data-id=" + id + "]").fadeIn();
      });
      menuPrev.on('click', function (ev) {
        ev.preventDefault();
        var level = $(this).data('level');
        menuLevel.hide();
        menuLevel.filter("[data-level=" + level + "]").fadeIn();
      });

      var fancystuff = $('.js-fancystuff');
      window.setTimeout(function () {
        fancystuff.toggleClass('is-ready');
      }, 500);

      var projectsFilter = $('.js-projects-filter');
      var projectsTile = $('.js-projects-tile');
      var projectsReset = $('.js-projects-reset');
      projectsTile.addClass('active');
      projectsFilter.on('click', function (ev) {
        ev.preventDefault();
        var category = $(this).data('filter');
        projectsFilter.removeClass('active');
        $(this).addClass('active');
        projectsTile.removeClass('active');
        projectsTile.filter(function () {
          var categories = $(this).data('categories');
          var response = categories.indexOf(category);
          if (response !== null && response >= 0) return true;
          else return false;
        }).addClass('active');
      });
      projectsReset.on('click', function (ev) {
        ev.preventDefault();
        projectsFilter.removeClass('active');
        projectsTile.addClass('active');
      });

      if (getURLParameter('category')) {
        projectsFilter.filter("[data-filter=" + getURLParameter('category') + "]").trigger('click');
      }

      var peoplePopup = $('.js-people-popup');
      var peoplePopupTrigger = $('.js-people-popup-trigger');
      peoplePopupTrigger.on('click', function (ev) {
        ev.preventDefault();
        var id = $(this).data('popup');
        var selected = peoplePopup.filter("[data-popup=" + id + "]");
        $.magnificPopup.open({
          items: {
            midClick: true,
            src: selected,
            type: 'inline'
          },
          autoFocusLast: false
        });
      });

      var galleryVideoLink = $('.js-video-link');
      galleryVideoLink.on('click', function (ev) {
        ev.preventDefault();
        var sourceVideo = "https://www.youtube.com/watch?v=" + $(this).data('youtube');
        $.magnificPopup.open({
          items: {
            src: sourceVideo
          },
          type: 'iframe',
          iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>',
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
              }
            },
            srcAction: 'iframe_src',
          }
        });
      });

      var projectInfo = $('.js-project-info');
      var projectInfoTrigger = $('.js-project-info-trigger');
      var projectInfoTimeout = window.setTimeout(function () {
        projectInfoTrigger.trigger('click');
      }, 5000);
      projectInfoTrigger.on('click', function (ev) {
        ev.preventDefault();
        window.clearTimeout(projectInfoTimeout);
        $(this).toggleClass('glyphicon-menu-left').toggleClass('glyphicon-menu-right');
        projectInfo.toggleClass('is-shrinked');
      });

      var projectGalleryTrigger = $('.js-project-gallery-trigger');
      var projectGalleryImages = $('.js-project-gallery-image');

      projectGalleryTrigger.on('click', function (ev) {
        ev.preventDefault();
        blueimp(projectGalleryImages, {
          container: '.js-project-gallery'
        });
      });

      var carousel = $('.js-carousel');
      carousel.owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        items: 1,
        autoplay: true,
        autoplayTimeout: 8000,
        autoplaySpeed: 1000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
      });

        var instagramCarousel = $('.js-instagram-carousel');
        instagramCarousel.owlCarousel({
            loop: true,
            nav: false,
            dots: false,
            items: 4,  // Set to 4 to display 4 items at a time
            autoplay: true,
            autoplayTimeout: 8000,
            autoplaySpeed: 1000,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            responsive: {
                0: {
                    items: 1  // Display 1 item on smaller screens
                },
                600: {
                    items: 2  // Display 2 items on screens 600px and larger
                },
                1000: {
                    items: 4  // Display 4 items on screens 1000px and larger
                }
                // Add more breakpoints and items settings as needed
            },
            navText: ['<span class="prev glyphicon glyphicon-menu-left"></span>', '<span class="next glyphicon glyphicon-menu-right"></span>']
        });

      var featureDevice = $('html').attr('class');
      var videoBlock = $('.js-video-block');
      var videoElement = $('.js-video');
      if ((videoBlock.length)) {

        videoElement.attr('preload', 'auto');
        var videoNative = videoElement.get(0);
        //play function
        var play = function () {
          videoNative.removeEventListener('canplaythrough', play, false);
          videoNative.removeEventListener('load', play, false);
          videoNative.play();
        };
        //start the video or feature banners
        if (featureDevice && featureDevice.indexOf('mobile') !== -1) {
          videoBlock.remove();
        } else if (featureDevice && featureDevice.indexOf('tablet') !== -1) {
          //change the preload type to preload video
          videoNative.setAttribute('controls', 'controls');
          play();
        } else if (videoNative.readyState >= videoNative.HAVE_FUTURE_DATA) {
          play();
        } else {
          videoNative.addEventListener('canplaythrough', play);
          videoNative.addEventListener('load', play);
        }
      }


    });

    function getURLParameter(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
    }

  })(jQuery);
}
